import { Directive, Injector, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { GuiComponent, HAlign } from "src/model/enum/enumCustomInterface";
import { AddressService } from "src/service/address.service";
import { TranslationService } from "src/service/translation.service";
import { clientSettings } from "src/state/selectors/client-settings.selectors";
import { ClientSettings } from "../client-settings";
import { Address } from "../../../components/shared-components/class/component-classes/address";
import { ComponentAggregation } from "./component-aggregation";
import { SupervisionComponentAPI } from "./supervision-component-api";

/**
 * This class is similar to generic basic guid.
 * Handle common property/method of all template component
 */
@Directive()
export class GenericBasicAggregateGUI {
  //#region Subcriptions to "_store.select(...)" Observables
  private _selectClientSettingsUserSub: Subscription = null;
  //#endregion

  private _currentClientSetting: ClientSettings = null;

  private _translationService: TranslationService = null;
  private _store: Store = null;

  public styleLabel = {};

  public labelAggregateNameComponent: SupervisionComponentAPI = null;
  public aggregateName: string = "";
  public hAlign = HAlign;

  @Input("") aggregate: ComponentAggregation;

  constructor(private _injector: Injector) {
    this.injectComponentService();

    this.subscribeSettingServiceData();
  }

  ngOnDestroy() {
    this.unsubscribeStoreSelect();
  }

  /**
   * Inject required service with injector object
   */
  private injectComponentService(): void {
    this._translationService = this._injector.get(TranslationService);
    this._store = this._injector.get(Store);
  }

  /**
   * Subsribe to public Observable "clientSettings" of "settings.service", which propagates the info about the general app
   * -related settings as defined for this device; it will also emit each time these settings are changed.
   */
  private subscribeSettingServiceData(): void {
    this._selectClientSettingsUserSub = this._store
      .select(clientSettings)
      .pipe(filter((clientSetting) => clientSetting !== null))
      .subscribe((clientSettings: ClientSettings) => {
        this._currentClientSetting = clientSettings;

        /** Overwrite font size in list view componet. This parameter is set on device */
        if (clientSettings.supervisionFontSize) {
          this.styleLabel["font-size"] =
            clientSettings.supervisionFontSize + "px";
        }
      });
  }

  //#region Unsubscribe from "_store.selec(...)" Observable
  /**
   * This method handles the unsunìbscription from the Observables returned by the "_store.select(...)" invocations.
   * It SHOULD BE CALLED EACH TIME THE DATA STREAMS ARE NOT NEEDED ANYMORE; this means in:
   *
   * * OnDestroy() [Components/Services]
   * * OnViewWillLeave() [Pages]
   */
  private unsubscribeStoreSelect(): void {
    if (this._selectClientSettingsUserSub) {
      this._selectClientSettingsUserSub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Search releated label component in aggregate component list
   */
  protected searchLabelNameComponent(): void {
    this.labelAggregateNameComponent = this.aggregate.listComponent.find(
      (component: SupervisionComponentAPI) =>
        component.code === GuiComponent.LABEL
    );
  }
}
